import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, distinctUntilChanged } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';
import { setTenantKey, updateTenantKey } from '../actions/tenant.actions'; // Assume this action updates the state directly
import { Store } from '@ngrx/store';
import { environment } from '@env/environment';

@Injectable()
export class TenantEffects {

    constructor(private actions$: Actions, private store: Store) {}

    encryptTenantKey$ = createEffect(() =>
        this.actions$.pipe(
            ofType(setTenantKey),
            map(({ tenantKey }) => {
                const encryptedKey = CryptoJS.AES.encrypt(tenantKey, environment.tenantKeyPassphrase).toString();
                this.store.dispatch(updateTenantKey({ tenantKey: encryptedKey })); 
            })
        ),
        { dispatch: false } // No action is dispatched from this effect
    );
}
